import api from "./api";
import { CountriesType } from "../components/References/Countries/countriesType";
export type DeleteCountryDto = {
  id: number | string;
};

export const getInitialPermissions = async () => {
  return await api.get("/countries/init-permissions");
};

export const getCountries = async () => {
  return await api.get("/countries");
};

/*search & filter & limit  */
export const getCountriesApi = async (body: { limit: number; q: string; isActive?: boolean }) => {
  let url = `/countries?limit=${body.limit}&q=${body.q}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};

export const getCountriesDropdown = async () => {
  const isArabicLang = localStorage.getItem('language') === 'ar' ? 1 : 0
  const res = await api.get(`/countries?arabicLocale=${isArabicLang}&limit=9999999`);
  return res.data
};

/*Delete Countries */
export const deleteCountries = async (dto: DeleteCountryDto) => {
  return await api.delete(`/countries/${dto.id}`);
};

/* get Countries ById*/
export const getCountriesById = async (countriesId: string | undefined) => {
  return await api.get(`/countries/${countriesId}`);
};

/* create Countries */
export const createCountries = async (countriesDetails: CountriesType) => {
  return await api.post("/countries", countriesDetails);
};

/* edit Countries*/
export const editCountries = async (countriesId: any, body: CountriesType) => {
  return await api.put(`/countries/${countriesId}`, body);
};
